import React, { useState } from "react";
import "./optimization.css";

const images = [
  { src: "/img/optimizer1.png", alt: "Screenshot ottimizzazione 1" },
  { src: "/img/optimizer2.png", alt: "Screenshot ottimizzazione 2" },
  { src: "/img/optimizer3.png", alt: "Screenshot ottimizzazione 3" }
];

export const Optimization = () => {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent((current - 1 + images.length) % images.length);
  const next = () => setCurrent((current + 1) % images.length);

  return (
    <section id="optimization" className="optimization-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 about-text">
            <h2>Ottimizzazione dei Trasporti</h2>
            <p>
              On Time offre un modulo di ottimizzatore algoritmico basato su AI che consente di minimizzare i costi di trasporto <strong>in pochi secondi</strong>.
            </p>
            <p>
              Grazie all'intelligenza artificiale, il nostro sistema analizza rapidamente tutte le variabili logistiche e propone le soluzioni più efficienti, garantendo risparmio e rapidità per la tua azienda.
            </p>
            <div className="optimization-carousel">
              <button className="carousel-btn left" onClick={prev} aria-label="Precedente">&#8592;</button>
              <img
                src={images[current].src}
                alt={images[current].alt}
                className="optimization-img"
              />
              <button className="carousel-btn right" onClick={next} aria-label="Successivo">&#8594;</button>
            </div>
            <div className="carousel-dots">
              {images.map((_, idx) => (
                <span
                  key={idx}
                  className={"dot" + (idx === current ? " active" : "")}
                  onClick={() => setCurrent(idx)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
